import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Sidebar.js';
import { Dashboard } from './pages/Dashboard.js';
import { Conditions } from './pages/Conditions.js';
import { Devices } from './pages/Devices.js';
import { AccountsCards } from './pages/AccountsCards.js';
import { Deadlines } from './pages/Deadlines.js';
import { Notifications } from './pages/Notifications.js';
import { Reconciliation } from './pages/Reconciliation.js';
import { Verify } from './pages/Verify.js';
import { Reports } from './pages/Reports.js';
import { Logins } from './pages/Logins.js';
import { Grants } from './pages/Grants.js';
import { Travel } from './pages/Travel.js';
import { Vehicles } from './pages/Vehicles.js';
import { Personal } from './pages/Personal.js';
import { Documents } from './pages/Documents.js';
import { PoliceLog } from './pages/PoliceLog.js';
import { Settings } from './pages/Settings.js';
import { InspectorPreview } from './pages/InspectorPreview.js';
import { Placeholder } from './pages/Placeholder.js';

export function App() {
  const [navOpen, setNavOpen] = useState(false);
  return (
    <div className="app">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      {navOpen && <div className="nav-backdrop" onClick={() => setNavOpen(false)} />}
      <main className="main">
        <div className="mobile-topbar">
          <button className="hamburger" type="button" aria-label="Open menu" onClick={() => setNavOpen(true)}>☰</button>
          <div className="mobile-brand"><span className="brand-mark" style={{ width: 26, height: 26, fontSize: 12 }}>S</span> SOR</div>
        </div>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/conditions" element={<Conditions />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/accounts" element={<AccountsCards />} />
          <Route path="/reminders" element={<Deadlines />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/reconciliation" element={<Reconciliation />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/logins" element={<Logins />} />
          <Route path="/grants" element={<Grants />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/personal" element={<Personal />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/police-log" element={<PoliceLog />} />
          <Route path="/inspector" element={<InspectorPreview />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Placeholder title="Not found" />} />
        </Routes>
      </main>
    </div>
  );
}
